import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getAdminSupportAction = createAsyncThunk(
    'get-admin-support',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-admin-support?`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAdminSupportSlice = createSlice({
    name: 'get-admin-support',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAdminSupportAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAdminSupportAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getAdminSupportAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getAdminSupportReducer = getAdminSupportSlice.reducer